import { createSlice } from "@reduxjs/toolkit";

// ---------------------------------------------------------------------------
// apiQueueSlice – simplified after RTK Query conversion
//
// The original manual queue serialized raw axios calls to prevent race
// conditions. RTK Query now manages all main data-fetching with built-in
// deduplication and caching, so the sequential queue is no longer needed.
//
// enqueueApiCall is kept with the same interface for the few remaining
// call-sites (ZoneButtons, CreateZoneButton, useHandleGlobalSearch) that
// still make direct axios calls.  It now executes the function directly
// instead of enqueuing it.
// ---------------------------------------------------------------------------

/**
 * Execute an API call directly.
 *
 * Previously queued calls sequentially; RTK Query now handles deduplication
 * and request management for all managed endpoints, so we simply invoke the
 * function and return its result.
 *
 * Usage (unchanged for callers):
 *   await dispatch(enqueueApiCall(async () => { ... }));
 */
export const enqueueApiCall = (apiCall) => (_dispatch) => {
  return apiCall();
};

const apiQueueSlice = createSlice({
  name: "apiQueue",
  initialState: {},
  reducers: {},
});

export default apiQueueSlice.reducer;
